<div class="select-your-plan">
  <div class="row">
    <div class="col-12 text-center p-2 w-100 pt-5">
      @if (title) {
        <div [innerHTML]="getHtml(title, null)"></div>
      }
      @if (!title) {
        <div>
          <h2>Select Your Plan</h2>
        </div>
      }
      <div [innerHTML]="getHtml(subTitle, null)"></div>
      @if (brandInfo.defaultDiscount[appFlowState] === 'FULLPAY5') {
        <div>
          <p>Get 5% off full payment with code <b>FULLPAY5</b></p>
        </div>
      }
    </div>
  </div>
  @if (!ratesBackground) {
    <div class="plans-container w-100">
      <ngx-slick-carousel #slickModal="slick-carousel" class="carousel w-100" [config]="slickConfig"
        (beforeChange)="beforeChange($event)">
        @for (plan of plansToDisplay; track $index; let i = $index) {
          <div ngxSlickItem class="slide"
            style="position:relative; text-align: center;">
            <div class="plan" [ngClass]="{'disabled': !plan.term}">
              <div class="plan-header">
                {{plan?.header ?? ''}}
                @if (plan?.tooltip) {
                  <i class="fas fa-info-circle" [htmlTooltip]="plan?.tooltip"
                    [htmlTooltipPosition]="'above'" [htmlTooltipClass]="'tooltips'">
                  </i>
                }
              </div>
              @if (!isWAState && !fullPayOnly && brand !== 'Lambo' && brand !== 'Porsche' && showInstallmentMessagingForPlan(plan)) {
                <div class="plan-price">
                  <strong>
                    @if (plan?.term?.payment) {
                      <span>${{ plan?.term?.payment | number: ".2" }}<sup>*</sup></span>
                    } @else {
                      <span>N/A</span>
                    }
                  </strong>
                </div>
              }
              @if (!isWAState && !fullPayOnly && brand !== 'Lambo' && brand !== 'Porsche' && showInstallmentMessagingForPlan(plan)) {
                <div class="plan-cost">
                  @if (plan?.term?.totalPrice) {
                    <span>{{ 'RATES_PAGE.TOTAL_COST_IS' | translate }} ${{plan?.term?.totalPrice | number: ".2" }}</span>
                  } @else {
                    <span>Unavailable Option</span>
                  }
                </div>
              }
              @if (isWAState || fullPayOnly || brand ==='Lambo' || brand === 'Porsche' || !showInstallmentMessagingForPlan(plan)) {
                <div class="plan-price">
                  <strong>
                    @if (plan?.term?.totalPrice) {
                      <span>${{ plan?.term?.totalPrice | number: ".2" }}<sup>*</sup></span>
                    } @else {
                      <span>N/A</span>
                    }
                  </strong>
                </div>
              }
              @if (!isWAState && !fullPayOnly && brand !== 'Lambo' && brand !== 'Porsche' && !showInstallmentMessagingForPlan(plan)) {
                <div class="plan-cost">
                  <span>{{ 'RATES_PAGE.FULL_PAYMENT_REQUIRED' | translate }}</span>
                </div>
              }

              <div class="plan-detail">{{ (showInstallmentMessagingForPlan(plan) && plan?.term?.payment) ? plan.subHeader : '&nbsp;' }}</div>
              @if (!multiDeductible && brand !== 'Lambo' && !plan.plan.planCode.includes('NCESI PPM')) {
                <div class="plan-deductible">
                  <hr />
                  <div class="mt-1">
                    {{ 'CART_CHECKOUT.DEDUCTIBLE_CLAIM' | translate }}<br /><strong>{{plan.plan.deductible | currency: "USD" :
                      "symbol-narrow" : "0.0": this.preferredLanguage}}</strong></div>
                </div>
              }
              <button id="selectPlanButton{{i}}" class="plan-button btn secondary-btn mt-3" style="font-size:80% !important"
                [ngClass]="{'highlighted': i === currentSelectedIndex}" (click)="selectPlan(i)">{{plan.name}}</button>
              <div id="{{plan.plan.referenceNumber}}" style="display: none;">PLAN REFERENCE NUMBER: {{plan.plan.referenceNumber}}</div>
            </div>
          </div>
        }
      </ngx-slick-carousel>
    </div>
  }

  @if (ratesBackground) {
    <div class="plans-container plans-container-cards w-100">
      <ngx-slick-carousel #slickModal="slick-carousel" class="carousel w-100" [config]="slickConfig"
        (beforeChange)="beforeChange($event)">
        @for (plan of plansToDisplay; track $index; let i = $index) {
          <div ngxSlickItem class="slide"
            style="position:relative; text-align: center;">
            <div id="selectPlanCard{{i}}" class="plan" [ngClass]="{'disabled': !plan.term, 'active': i === currentSelectedIndex}" (click)="selectPlan(i)">
              <div class="plan-header">
                {{plan?.header ?? ''}}
                @if (plan?.tooltip) {
                  <i class="fas fa-info-circle" [htmlTooltip]="plan?.tooltip"
                    [htmlTooltipPosition]="'above'" [htmlTooltipClass]="'tooltips'">
                  </i>
                }
              </div>
              @if (!isWAState && !fullPayOnly && brand !== 'Lambo' && brand !== 'Porsche' && showInstallmentMessagingForPlan(plan)) {
                <div class="plan-price">
                  <strong>
                    @if (plan?.term?.payment) {
                      <span>${{ plan?.term?.payment | number: ".2" }}<sup>*</sup></span>
                    } @else {
                      <span>N/A</span>
                    }
                  </strong>
                </div>
              }
              @if (!isWAState && !fullPayOnly && brand !== 'Lambo' && brand !== 'Porsche' && showInstallmentMessagingForPlan(plan)) {
                <div class="plan-cost">
                  @if (plan?.term?.totalPrice) {
                    <span>{{ 'RATES_PAGE.TOTAL_COST_IS' | translate }} ${{plan?.term?.totalPrice | number: ".2" }}</span>
                  } @else {
                    <span>Unavailable Option</span>
                  }
                </div>
              }
              @if (isWAState || fullPayOnly || brand ==='Lambo' || brand === 'Porsche' || !showInstallmentMessagingForPlan(plan)) {
                <div class="plan-price">
                  <strong>
                    @if (plan?.term?.totalPrice) {
                      <span>${{ plan?.term?.totalPrice | number: ".2" }}<sup>*</sup></span>
                    } @else {
                      <span>N/A</span>
                    }
                  </strong>
                </div>
              }
              @if (!isWAState && !fullPayOnly && brand !== 'Lambo' && brand !== 'Porsche' && !showInstallmentMessagingForPlan(plan)) {
                <div class="plan-cost">
                  <span>{{ 'RATES_PAGE.FULL_PAYMENT_REQUIRED' | translate }}</span>
                </div>
              }

              <!-- NCESI needs to show deductible only for ASP -->
              @if (!multiDeductible && brand !== 'Lambo' && !plan.plan.planCode.includes('NCESI PPM')) {
                <div class="plan-deductible">
                  <hr />
                  <div class="mt-1">
                    {{ 'CART_CHECKOUT.DEDUCTIBLE_CLAIM' | translate }}<br /><strong>{{plan.plan.deductible | currency: "USD" :
                      "symbol-narrow" : "0.0": this.preferredLanguage}}</strong></div>
                </div>
              }

              <div class="plan-details">
                <hr />
                <div class="plan-name">{{plan.name}}</div>

                <div class="plan-details-text" [innerHTML]="plan.ratePlanDetails"></div>
                
                <div id="{{plan.plan.referenceNumber}}" style="display: none;">PLAN REFERENCE NUMBER: {{plan.plan.referenceNumber}}</div>
              </div>
            </div>
          </div>
        }
      </ngx-slick-carousel>
    </div>
  }

  <div class="row">
    <div class="col-12 text-center p-2 w-100">
      <div class="plans-footer">
        @if (!isWAState && !fullPayOnly && brand !=='Lambo' && brand !== 'Porsche') {
          @if (hasMixedCapPlans()) {
            <div class="plans-footer-text">
              {{ 'RATES_PAGE.MIXED_CAP_FOOTER' | translate: {
                numberOfPayments: paymentPlanCount,
                noFee: noFee,
                capAmount: footerCapAmountDisplay
              } }}
            </div>
          } @else if (showInstallmentMessaging()) {
            <div class="plans-footer-text">
              {{ 'RATES_PAGE.LOWEST_MONTHLY_1' | translate }}
              <strong> {{ 'RATES_PAGE.SPLIT_PAYMENT' | translate: { numberOfPayments: paymentPlanCount,
                noFee: noFee } }}</strong>
              @if (brand !== 'NCESI') {
                <span>{{ 'RATES_PAGE.SPLIT_MONTHLY_3' | translate: { deductible: footerDeductibleDisplay } }}</span>
              }
              <div class="plans-footer-text">
                {{ 'RATES_PAGE.PRICES_EXCLUDE_DUE' | translate }}
              </div>
            </div>
          } @else {
            <div class="plans-footer-text">
              *{{ 'RATES_PAGE.PRICES_EXCLUDE_DUE' | translate }}
            </div>
          }
        } @else {
          <div class="plans-footer-text">
            *{{ 'RATES_PAGE.PRICES_EXCLUDE' | translate }}
          </div>
        }
      </div>
    </div>
  </div>
  <div class="row syp-add-to-cart">
    <div class="col-12 text-center p-2 w-100 desktop">
      <div class="sub-button-container">
        <div class="sub-button">
          <button id="addToCartButton" (click)="addToCart()" class="btn primary-btn">{{ 'RATES_PAGE.ADD_TO_CART' | translate }}</button>
        </div>
      </div>
    </div>
    @if (paypal) {
      <div class="col-12 text-center p-2 w-100">
        <div class="paypal-checkout-option">
          <div class="paypal-select-pay-logo">
            <img src="../../../assets//paypal/paypal-select-your-paln.png">
          </div>
          <div class="text"> {{ 'RATES_PAGE.PAYPAL_PAYMENT_AVAILABILITY' | translate }}</div>
        </div>
      </div>
    }
  </div>
</div>